import { InjectionToken } from '@angular/core';

export const PRISMIC_ENDPOINT = new InjectionToken<string>('PrismicEndpoint');
